import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://public.readdy.ai/ai/img_res/3e6b5bec28bff24e3405b770e3527a5f.jpg"
              alt="Beautiful home"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0F2A50]/95 via-[#0F2A50]/80 to-[#0F2A50]/50"></div>
          </div>

          <div className="relative z-10 px-8 md:px-16 py-16 md:py-20">
            <div className="max-w-xl">
              <span className="inline-block text-sky-400 text-xs font-bold uppercase tracking-widest mb-4">
                {t('about_cta_tag')}
              </span>
              <h2 className="text-white font-bold text-3xl md:text-4xl leading-tight mb-4">
                {t('about_cta_title1')} <br />
                <span className="text-sky-400">{t('about_cta_title2')}</span>
              </h2>
              <p className="text-white/70 text-base leading-relaxed mb-8">
                {t('about_cta_desc')}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/water-purification"
                  className="inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-drop-line text-base"></i>
                  </div>
                  {t('about_cta_btn1')}
                </Link>
                <Link
                  to="/windows-services"
                  className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white/60 text-white font-semibold px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-window-line text-base"></i>
                  </div>
                  {t('about_cta_btn2')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
